import { useState } from 'react';
import PreviewContainer from './PreviewContaner';


const NotificationPreview = (props) => {


    const [selectedOs, setSelectedOs] = useState('Windows');
    const [selectedBrowser, setSelectedBrowser] = useState('Chrome')

    const windowsPreviews = ['Chrome', 'Firefox', 'Opera'];
    const androidPreviews = ['Chrome', 'Firefox', 'Opera'];
    const macOsPreviews = ['Safari', 'Chrome', 'Firefox', 'Opera'];

    const getPreviewDropDowns = () => {
        if(selectedOs === 'Windows') {
            return windowsPreviews;
        }
        if(selectedOs === 'Android') {
            return androidPreviews;
        }
        return macOsPreviews;
    }

    const onChangeOs = (value) => {
        setSelectedBrowser('Chrome');
        setSelectedOs(value)
    }

    return <div className="col notification-preview-container d-sm-none d-md-block">
    <div className="box" style={{position: 'sticky', top: '0px'}} >
        <div className="d-flex mb-2">
            <h5 className="medium">Notification Preview</h5>
            {/* <a href="" className="ml-auto">Test Notifications</a> */}
        </div>
        <div className="d-flex justify-content-between mb-3">
            <div className="custom-control custom-radio">
                <input 
                    type="radio"  
                    id="customRadio6" 
                    name="customRadio" 
                    className="custom-control-input" 
                    value='Windows'
                    checked={selectedOs === 'Windows'}
                    onChange={({target}) => onChangeOs(target.value)}    
                />
                <label className="custom-control-label" htmlFor="customRadio6">Windows</label>
            </div>
            <div className="custom-control custom-radio">
                <input 
                    type="radio" 
                    id="customRadio7" 
                    name="customRadio" 
                    className="custom-control-input" 
                    value='Android'
                    checked={selectedOs === 'Android'}
                    onChange={({target}) => onChangeOs(target.value)}
                />
                <label className="custom-control-label" htmlFor="customRadio7">Android</label>
            </div>
            <div className="custom-control custom-radio">
                <input 
                    type="radio" 
                    id="customRadio8" 
                    name="customRadio" 
                    className="custom-control-input" 
                    value='MacOs'
                    checked={selectedOs === 'MacOs'}
                    onChange={({target}) => onChangeOs(target.value)}
                    />
                <label className="custom-control-label" htmlFor="customRadio8">Mac OS</label>
            </div>
        </div>
        <div className="form-group">
            <select value={selectedBrowser} onChange={({target}) => setSelectedBrowser(target.value)} className="form-control">
                {
                    getPreviewDropDowns().map((browser, index) => <option value={browser} key={index}>{browser}</option> )
                }
                {/* <option>Chrome on android</option>
                <option>Mozilla on android</option> */}
            </select>
        </div>

     <PreviewContainer {...props} osSelected={selectedOs} browserSelected={selectedBrowser} />   
     
    </div>
</div>

}

export default NotificationPreview;